<template>
  <button class="btn btn-red w-100" data-bs-toggle="modal" data-bs-target="#post-remove">
    <template v-if="isTypeTelegram()">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M4 7l16 0" />
      <path d="M10 11l0 6" />
      <path d="M14 11l0 6" />
      <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
    </svg>
    </template>
    <template v-if="isTypeSite()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="icon icon-tabler icons-tabler-outline icon-tabler-bulb-off me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path
          d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"/><path
          d="M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"/><path
          d="M9.7 17h4.6"/><path d="M3 3l18 18"/>
      </svg>
    </template>
    <template v-if="obj.status.isPreDeleted()">
      Повторить удаление
    </template>
    <template v-else>
      <template v-if="isTypeTelegram()">
        Удалить
      </template>
      <template v-if="isTypeSite()">
        Выключить
      </template>
    </template>
  </button>

  <div class="modal modal-blur fade" id="post-remove" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <template v-if="isTypeTelegram()">
          <h5 class="modal-title">Удаление</h5>
          </template>
          <template v-if="isTypeSite()">
            <h5 class="modal-title">Выключение</h5>
          </template>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeModal"></button>
        </div>
        <div class="modal-body">
          <button class="btn btn-red w-100 mb-3" :class="{'disabled': isDisabledBtn()}" @click="onDelete">
            <span class="spinner-border spinner-border-sm me-2" v-show="isShowLoadingBtn()"></span>
            <template v-if="isTypeTelegram()">
              Удалить
            </template>
            <template v-if="isTypeSite()">
              Выключить
            </template>
          </button>
          <button class="btn btn-warning w-100" :class="{'disabled': isDisabledChainBtn()}" @click="onDeleteChain">
            <span class="spinner-border spinner-border-sm me-2" v-show="isShowLoadingChainBtn()"></span>
            <template v-if="isTypeTelegram()">
              Удалить цепочку постов
            </template>
            <template v-if="isTypeSite()">
              Выключить цепочку постов
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref} from "vue"
import Api from "./services/Api"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "Remove",
  emits: [
      "onPostRemove",
  ],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    let deleting = ref(false)
    let deletingChain = ref(false)
    let closeModal = ref(null)

    let postId = ref(props.data["post_id"])
    let postInChain = ref(props.data["post_in_chain"])
    let status = ref(props.data["status"])
    let type = ref(props.data["type"])

    function onDelete() {
      let question = ""

      if (isTypeTelegram()) {
        question = "Вы действительно хотите удалить пост?"
      } else if (isTypeSite()) {
        question = "Вы действительно хотите выключить пост?"
      } else {
        throw new Error("Неверный тип")
      }

      if (confirm(question)) {
        startDeleting()

        let handler

        if (isTypeTelegram()) {
          handler = Api.telegramDelete(postId.value)
        } else if (isTypeSite()) {
          handler = Api.siteDelete(postId.value)
        } else {
          throw new Error("Неверный тип")
        }

        handler.then(() => {
          setTimeout(() => {
            emit('onPostRemove', true)
          }, 1500)
        }).then(() => {
          if (isTypeSite()) {
            Notify.success("Поставлена задача на выключение")
          }

          if (isTypeTelegram()) {
            Notify.success("Поставлена задача на удаление")
          }
          closeModalWindow()
        }).catch(() => {
          emit('onPostRemove', false)
        }).finally(() => {
          stopDeleting()
        })
      }
    }

    function isTypeTelegram() {
      return type.value === "telegram"
    }

    function isTypeSite() {
      return type.value === "site"
    }

    function onDeleteChain() {
      let question = ""

      if (isTypeTelegram()) {
        question = "Вы действительно хотите удалить всю цепочку постов?"
      } else if (isTypeSite()) {
        question = "Вы действительно хотите выключить всю цепочку постов?"
      } else {
        throw new Error("Неверный тип")
      }

      if (confirm(question)) {
        startDeletingChain()

        Api.deleteChain(postId.value).then(() => {
          setTimeout(() => {
            emit('onPostRemove', true)
          }, 1500)
        }).then(() => {
          if (isTypeSite()) {
            Notify.success("Цепочка выключена")
          }

          if (isTypeTelegram()) {
            Notify.success("Цепочка удалена")
          }
          closeModalWindow()
        }).catch(() => {
          emit('onPostRemove', false)
        }).finally(() => {
          stopDeletingChain()
        })
      }
    }

    function isDisabledBtn() {
      return deleting.value === true
    }

    function isShowLoadingBtn() {
      return isDisabledBtn()
    }

    function isDisabledChainBtn() {
      return deletingChain.value === true || (postInChain.value === 0)
    }

    function isShowLoadingChainBtn() {
      return deletingChain.value === true
    }

    function startDeleting() {
      deleting.value = true
    }

    function stopDeleting() {
      deleting.value = false
    }

    function startDeletingChain() {
      deletingChain.value = true
    }

    function stopDeletingChain() {
      deletingChain.value = false
    }

    function closeModalWindow() {
      closeModal.value.click()
    }

    let obj = {
      status: {
        isPreDeleted: () => {
          return status.value === "preDeleted"
        },
      },
    }

    return {
      onDelete,
      onDeleteChain,
      isDisabledBtn,
      isShowLoadingBtn,
      isDisabledChainBtn,
      isShowLoadingChainBtn,
      closeModal,
      obj,
      isTypeTelegram,
      isTypeSite,
    }
  },
})
</script>

<style scoped>

</style>
